var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m416 512h-320c-53.023 0-96-42.977-96-96v-320c0-53.023 42.977-96 96-96h320c53.023 0 96 42.977 96 96v320c0 53.023-42.977 96-96 96z",
    fill: "#e3f8fa",
    style: {},
    "data-original": "#e3f8fa",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m376 363.11h-138.67c-5.8867 0-10.672-4.7852-10.672-10.672 0-5.8906 4.7852-10.672 10.672-10.672h138.67c5.8867 0 10.672 4.7812 10.672 10.672 0 5.9023-4.7852 10.672-10.672 10.672z",
    fill: "#2a93d4",
    style: {},
    "data-original": "#8ce1eb",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m346.85 172.67-15.086-15.086c-8.0664-8.0664-22.113-8.0664-30.16 0l-22.066 22.062 45.25 45.246 22.062-22.062c4.0312-4.0312 6.2578-9.375 6.2578-15.09 0-5.6797-2.2266-11.039-6.2578-15.07z",
    fill: "#2a93d4",
    style: {},
    "data-original": "#8ce1eb",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m264.46 194.73-109.94 109.94c-0.70312 0.70312-1.1992 1.5859-1.4219 2.543l-11.633 49.344c-0.41797 1.793 0.11328 3.6797 1.4219 4.9922 1.0078 1.0078 2.3711 1.5703 3.7773 1.5703 0.39844 0 0.81641-0.050782 1.2148-0.14453l49.344-11.633c0.96094-0.22266 1.8594-0.71875 2.5469-1.4219l109.93-109.94z",
    fill: "#00416d",
    style: {},
    "data-original": "#26c6da",
    xmlns: "http://www.w3.org/2000/svg"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.61229913.svg";
export { ForwardRef as ReactComponent };